import React, { useState } from 'react';
import PageContainer from '../../components/container/PageContainer';
import { Box, CircularProgress, Tab, Tabs, Typography } from '@mui/material';
import Reports from '../reports';

function NewReports() {
  return (
    <PageContainer title="Reports" description="Reports">
      <Box sx={{ mt: 3, p: 10 }}>
        <Reports />
      </Box>
    </PageContainer>
  );
}
  
export default NewReports;
